import type { Components, Theme } from "@mui/material/styles";

export const MuiAlertTitle: NonNullable<Components<Theme>["MuiAlertTitle"]> = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.bodyMdSemiBold,
      marginBottom: theme.spacing(1),
    }),
  },
};
